import { render, staticRenderFns } from "./ModalExceedLicense.vue?vue&type=template&id=72fdd794&"
import script from "./ModalExceedLicense.vue?vue&type=script&lang=js&"
export * from "./ModalExceedLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports